import React from 'react';
import classNames from 'classnames';
import numeral from 'numeral';
import { InputBaseProps } from '../../../../interfaces/interfaces';

interface NumberInputProps extends InputBaseProps {
	label?: string,
	invalid?: boolean,
	invalidMessage?: string,
	currency?: boolean,
	maxLength?: number,
	commaSeparated?: boolean,
}

const NumberInput = ({ id, label, currency, commaSeparated, invalid, invalidMessage, className, placeholder, value, onBlur, onInput, onChange, maxLength = 14 }: NumberInputProps) => {

	const formattedValue = (value === '0' || value === '') ? value :
		commaSeparated ? numeral(value).format() : value;

	return (
		<div className="col px-0">
			<label htmlFor={id} className="mb-0">
				{label}
			</label>
			<div className="cc-input-group w-100">
				{currency && <div className="cc-input-group__text">$</div>}
				<input
					inputMode="decimal" // shows only numbers on mobile keyboard
					id={id}
					className={classNames(invalid && 'cc-input-field--invalid', className && className)}
					placeholder={placeholder}
					maxLength={maxLength}
					value={formattedValue}
					onKeyPress={(event) => {
						if (!/[0-9]/.test(event.key)) {
							event.preventDefault();
						}
					}}
					onBlur={onBlur}
					onInput={onInput}
					onChange={event => onChange(event.currentTarget.value)}
				/>
			</div>
			{invalid && invalidMessage && (
				<div className="invalid-error-message--input-field">{invalidMessage}</div>
			)}
		</div>
	);
};

export default NumberInput;